import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    width: 100%;
  }

  .player-container {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    background: var(--color-background-secondary, #000);
    border-radius: 8px;
    overflow: hidden;
  }

  .video-wrapper {
    position: relative;
    width: 100%;
    aspect-ratio: 16 / 9;
    max-height: var(--player-max-height, calc(100vh - var(--player-header-offset, 68px)));
    background: #000;
    transition:
      aspect-ratio 0.3s ease,
      max-width 0.3s ease,
      max-height 0.3s ease;
  }

  .video-wrapper.portrait {
    padding-bottom: 0;
    aspect-ratio: 9 / 16;
    max-width: min(450px, 100%);
    max-height: var(--player-portrait-max-height, 80vh);
    margin: 0 auto;
  }

  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  @media (max-width: 768px) {
    .player-container {
      border-radius: 0;
    }

    .video-wrapper.portrait {
      max-width: 100%;
      max-height: var(--player-portrait-max-height, 85vh);
    }
  }

  .loading-state,
  .waiting-state,
  .autoplay-blocked-state,
  .error-state {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    text-align: center;
    color: var(--color-text-primary, #eee);
  }

  .loading-state,
  .waiting-state,
  .autoplay-blocked-state,
  .error-state {
    padding: var(--sds-size-space-800);
  }

  .loading-state,
  .waiting-state {
    background: #111;
  }

  .waiting-title {
    font-size: 16px;
    font-weight: 600;
    line-height: 1.4;
    max-width: 480px;
  }

  .waiting-body {
    font-size: 14px;
    line-height: 1.5;
    max-width: 480px;
    opacity: 0.85;
    white-space: pre-line;
  }

  .autoplay-blocked-state {
    background: rgb(0 0 0 / 0.7);
    cursor: pointer;
    transition: background 0.2s;
  }

  .autoplay-blocked-state:hover {
    background: rgb(0 0 0 / 0.5);
  }

  .play-icon {
    font-size: 48px;
    opacity: 0.9;
  }

  .error-state {
    background: #1a0000;
  }

  .spinner {
    width: 48px;
    height: 48px;
    border: 4px solid rgb(255 255 255 / 0.1);
    border-top-color: var(--color-primary, #fff);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }

  .error-message {
    font-size: 14px;
    line-height: 1.5;
    opacity: 0.8;
  }

  .retry-button {
    padding: 12px 24px;
    background: var(--color-primary, #fff);
    color: var(--color-background-primary, #000);
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: opacity 0.2s;
  }

  .retry-button:hover {
    opacity: 0.9;
  }

  .retry-button:active {
    opacity: 0.8;
  }

  /* Debug overlay styles */
  .debug-overlay {
    opacity: 0.9;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    background: rgb(0 0 0 / 1);
    color: #fff;
    font-family: "SF Mono", Monaco, "Cascadia Code", monospace;
    font-size: 11px;
    padding: 8px;
    pointer-events: none;
    z-index: 9999;
    line-height: 1.4;
  }

  .debug-section {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
  }

  .debug-section:last-child {
    margin-bottom: 0;
  }

  .debug-label {
    color: #888;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    flex-shrink: 0;
  }

  .debug-buffer-wrapper {
    flex: 1;
    min-width: 0;
  }

  .debug-buffer-canvas {
    width: 100%;
    height: 16px;
    background: #222;
    border-radius: 2px;
    display: block;
  }

  .debug-levels {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .debug-level {
    padding: 2px 6px;
    background: #333;
    border-radius: 3px;
    font-size: 10px;
    color: #aaa;
  }

  .debug-level.active {
    background: #0066cc;
    color: #fff;
    font-weight: 600;
  }

  .debug-bitrate-section {
    display: block;
    margin-bottom: 6px;
  }

  .debug-bitrate-label {
    color: #888;
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
  }

  .debug-bitrate-value {
    margin-left: 8px;
  }

  .debug-bitrate-current {
    color: #f44;
  }

  .debug-bitrate-bandwidth {
    color: #fd0;
  }

  .debug-bitrate-canvas {
    width: 100%;
    height: 150px;
    background: #1a1a1a;
    border-radius: 2px;
    display: block;
  }

  .debug-stats-row {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    color: #ccc;
  }

  .debug-stats-row span {
    white-space: nowrap;
  }

  .debug-stats-row .error {
    color: #ff6b6b;
  }

  .debug-stats-row .warning {
    color: #ffc107;
  }
`;
